var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.17,
    height: 23,
    viewBox: "0 0 78.17 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M415.852,0V3.067h-6.73V23H405.8V3.477l.411-.41L409.277,0Z",
    transform: "translate(-387.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x1: 0.011,
    transform: "translate(13.709 3.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 0.016,
    y1: 0.007,
    transform: "translate(10.406 11.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M0,6.775A6.776,6.776,0,0,1,6.773,0H16.841L13.776,3.067l-.068.065H6.33l-.03,0A3.677,3.677,0,0,0,3.1,6.774c0,2.043,1.569,2.594,2.974,3.067L6.26,9.9l.518.165L4.569,12.272a8.282,8.282,0,0,1-1.589-.7C1.187,10.356,0,9.106,0,6.775Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M14.671,258.559A6.3,6.3,0,0,1,8.38,264.85L0,264.81v-3.1l8.369.032a3.175,3.175,0,0,0,3.17-3v-.354c0-1.512-1.97-2.1-3.562-2.6l2.445-2.444.473.211.131.058c.1.045.2.091.308.136.314.139.67.3.788.363C14.051,255.177,14.671,256.256,14.671,258.559Z",
    transform: "translate(0 -241.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M529.172,153.909v3.039h-7.719v2.033a1.16,1.16,0,0,0,1.143,1.14h6.576v3.015h-6.621a4.123,4.123,0,0,1-4.111-4.111v-7.193a4.123,4.123,0,0,1,4.111-4.111h6.623l-.913,3.037H522.6a1.145,1.145,0,0,0-1.142,1.142v3.541l1.53-1.53Z",
    transform: "translate(-494.907 -141.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M810.409,159.439v3.009H804a4.115,4.115,0,0,1-4.1-4.1v-7.181a4.115,4.115,0,0,1,4.1-4.1h6.406l-.912,3.032H804.05a1.143,1.143,0,0,0-1.141,1.141V158.3a1.158,1.158,0,0,0,1.14,1.14Z",
    transform: "translate(-763.59 -140.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 3.021,
    height: 3.021,
    transform: "translate(61.692 19.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1081.546,163.594h-3.021v-6.156h-5.339v6.156h-3V148.26h3v7.678l1.523-1.522h3.816V148.26h3.021Z",
    transform: "translate(-1021.611 -141.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1472.868,257.145h-2.137v-1.061l-1.061,1.061h-3.2a2.12,2.12,0,0,1-2.122-2.122v-2.239a2.133,2.133,0,0,1,2.122-2.138h2.845l.627,2.138h-3.038a.429.429,0,0,0-.434.418v1.385a.432.432,0,0,0,.434.434h3.825v-6.206a.405.405,0,0,0-.418-.418H1465.2l.643-2.138h4.886a2.126,2.126,0,0,1,2.137,2.138Z",
    transform: "translate(-1397.879 -235.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1677.471,257.145V246.26h-2.121v10.885Z",
    transform: "translate(-1599.301 -235.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1677.471,149.182V147.06h-2.121v2.122Z",
    transform: "translate(-1599.301 -140.385)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStech);
export default __webpack_public_path__ + "static/media/Stech.2482205997d4d7b684562435f36200f2.svg";
export { ForwardRef as ReactComponent };